// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDwY4jdEktaGb8b_fpQsuts-F9G7hypv3o",
  authDomain: "unframed-ai.firebaseapp.com",
  projectId: "unframed-ai",
  storageBucket: "unframed-ai.firebasestorage.app",
  messagingSenderId: "516424767275",
  appId: "1:516424767275:web:212bd90c600d930134576e"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);